import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon EmailIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const EmailIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 14">
      <path d="M19.6,0.81c0-0.05-0.06-0.11-0.1-0.15h-0.05C19.08,0.25,18.55,0.01,18,0H2C0.9,0,0,0.9,0,2v10c0,1.1,0.9,2,2,2h16 c1.1,0,2-0.9,2-2V2C20,1.57,19.86,1.15,19.6,0.81z M17.6,1.5l-7.53,7.79L2.26,1.5H17.6z M1.5,11.44V2.86l4.29,4.29L1.5,11.44z  M2.56,12.5l4.3-4.29l2.68,2.68c0.14,0.14,0.33,0.22,0.53,0.22l0,0c0.2,0,0.39-0.08,0.53-0.23l2.57-2.64l4.26,4.26L2.56,12.5z  M18.5,11.44l-4.28-4.28l4.28-4.4V11.44z" />
    </Icon>
  )
}
export default EmailIcon
